// src/ManageChallenges.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function ManageChallenges() {
  const [challenges, setChallenges] = useState([]);
  const [form, setForm] = useState({
    title: "",
    description: "",
    challenge_type: "",
    requirement: "",
    reward: "",
    repeat_interval: "",
    stat_key: ""
  });
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  // Fetch all challenges
  useEffect(() => {
    fetch("https://auth.fnrewards.com/api/admin/challenges", {
      method: "GET",
      credentials: "include"
    })
      .then(res => res.json())
      .then(data => setChallenges(data.challenges))
      .catch(err => setError(err.message));
  }, []);

  const handleChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      const res = await fetch("https://auth.fnrewards.com/api/admin/challenges", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Failed to create challenge");
      } else {
        setMessage(data.message);
        // Refresh the challenge list
        const updatedRes = await fetch("https://auth.fnrewards.com/api/admin/challenges", {
          method: "GET",
          credentials: "include"
        });
        const updatedData = await updatedRes.json();
        setChallenges(updatedData.challenges);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDelete = async (challengeId) => {
    try {
      // Send a DELETE request with the challenge id as a query parameter.
      const res = await fetch(`https://auth.fnrewards.com/api/admin/challenge/delete?id=${challengeId}`, {
        method: "DELETE",
        credentials: "include"
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Failed to delete challenge");
      } else {
        setMessage(data.message);
        // Refresh the list after deletion
        setChallenges(challenges.filter(ch => ch.id !== challengeId));
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h1>Manage Challenges</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {message && <p style={{ color: "green" }}>{message}</p>}
      <h2>Create New Challenge</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Title:</label>
          <input name="title" value={form.title} onChange={handleChange} required />
        </div>
        <div>
          <label>Description:</label>
          <input name="description" value={form.description} onChange={handleChange} required />
        </div>
        <div>
          <label>Challenge Type:</label>
          <input name="challenge_type" value={form.challenge_type} onChange={handleChange} required />
        </div>
        <div>
          <label>Requirement (number):</label>
          <input name="requirement" type="number" value={form.requirement} onChange={handleChange} required />
        </div>
        <div>
          <label>Reward (credits):</label>
          <input name="reward" type="number" value={form.reward} onChange={handleChange} required />
        </div>
        <div>
          <label>Repeat Interval:</label>
          <input name="repeat_interval" value={form.repeat_interval} onChange={handleChange} placeholder="e.g., daily, weekly or leave blank" />
        </div>
        <div>
          <label>Stat Key:</label>
          <input name="stat_key" value={form.stat_key} onChange={handleChange} placeholder="e.g., global_stats.solo.kills" required />
        </div>
        <button type="submit">Create Challenge</button>
      </form>
      
      <h2>Current Challenges</h2>
      <ul>
        {challenges.map(challenge => (
          <li key={challenge.id}>
            <strong>{challenge.title}</strong> – {challenge.description} 
            <br />
            Type: {challenge.challenge_type} | Requirement: {challenge.requirement} | Reward: {challenge.reward} | Stat Key: {challenge.stat_key}
            <br />
            <button onClick={() => handleDelete(challenge.id)}>Delete the challenge</button>
            &nbsp;
            <Link to={`/admin/challenge/edit/${challenge.id}`}>Edit</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ManageChallenges;